import { useLocation, useNavigate, useParams } from "react-router-dom";
import uitoolkit, { CustomizationOptions } from "@zoom/videosdk-ui-toolkit";
// @ts-ignore
import "@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css";
import { useGetZoomServerConfig } from "../hooks/useMeeting";
import { useEffect, useRef, useState } from "react";
import uitoolkitIT from '../assets/videosdk-ui-toolkit-it-IT.json'
import { getAxiosTranslatedError } from "../utils/helpers";
import TelemedicinePage from "../components/telemedicinePage";
import TitleModal from "../components/common/titleModal";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ButtonSubmit from "../components/common/buttonSubmit";

interface ZoomServerConfig {
  videoSDKJWT: string
  sessionName: string
  userName: string
}

function TelemedicineMeeting() {
  const { t } = useTranslation()
  const { meetingToken = '' } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const backUrl = location.state?.from

  const [showLoading, setShowLoading] = useState(true)
  const [showSessionEnded, setShowSessionEnded] = useState(false)
  const [serverConfig, setServerConfig] = useState<ZoomServerConfig>()
  const [errorMessage, setErrorMessage] = useState('')

  const sessionContainer = useRef(null);

  const { mutate: getZoomToken } = useGetZoomServerConfig()

  useEffect(() => {
    getZoomToken(
      { token: meetingToken },
      {
        onSuccess: (response) => {
          setServerConfig(response)
        },
        onError: (error: any) => {
          setErrorMessage(getAxiosTranslatedError(error))
        },
      }
    )
  }, [])

  useEffect(() => {
    if (serverConfig) {
      joinSession()
    }
  }, [serverConfig])

  const config: CustomizationOptions = {
    videoSDKJWT: serverConfig?.videoSDKJWT || '',
    sessionName: serverConfig?.sessionName || '',
    userName: serverConfig?.userName || 'User',
    featuresOptions: {
      preview: { enable: false },
      virtualBackground: { enable: true },
      feedback: { enable: false },
      chat: { enable: false, enableEmoji: false },
      recording: { enable: false },
      subsession: { enable: false },
      header: { enable: false },
      caption: { enable: false },
      invite: { enable: false },
      whiteboard: { enable: false },
      theme: { enable: true, defaultTheme: 'green' },
    },
    language: 'it-IT',
  };

  function joinSession() {
    if (sessionContainer.current) {
      // Cleanup if something remains under the hood...
      try {
        uitoolkit.destroy();
      } catch (e) {
        console.log(e)
        console.log('nothing to destroy...')
      }

      setShowLoading(false)
      uitoolkit.joinSession(sessionContainer.current, config);

      uitoolkit.i18n.setLanguageList(["en-US", "it-IT"]);
      uitoolkit.i18n.setLanguage("it-IT", uitoolkitIT);

      sessionContainer.current && uitoolkit.onSessionClosed(sessionClosed);
      uitoolkit.onSessionDestroyed(sessionDestroyed);
    } else {
      console.error('sessionContainer.current not exists!! cannot join!!')
    }
  }

  const sessionClosed = () => {
    console.log("session closed");
    setShowSessionEnded(true)
  };

  const sessionDestroyed = () => {
    console.log("session destroyed");
    uitoolkit.destroy();
  };

  const handleCloseWindow = () => {
    window.close()
  }

  const handleGoBack = () => {
    navigate(backUrl)
  }

  const CloseButton = <ButtonSubmit
    className="btnMeeting mt-4"
    textButton={t("telemedicine-join.close-window")}
    handleChange={() => { handleCloseWindow() }}
  />

  const BackButton = <ButtonSubmit
    className="btnMeeting mt-4"
    textButton={t("telemedicine-join.go-back")}
    handleChange={() => { handleGoBack() }}
  />

  const EndSessionButton = backUrl ? BackButton : CloseButton

  return (
    <>
      {showLoading && <TelemedicinePage>
        {!errorMessage &&
          <>
            <TitleModal title={t('telemedicine-join.loading-meeting')} />
            <Spinner />
          </>
        }
        {errorMessage && <p>{errorMessage}</p>}
      </TelemedicinePage>
      }

      <div ref={sessionContainer} style={{
        height: '100vh',
        width: '100vw',
        display: showSessionEnded || showLoading ? 'none' : 'block'
      }}></div>

      {showSessionEnded && <TelemedicinePage>
        <TitleModal title={t("telemedicine-join.finished-visit")} />
        {EndSessionButton}
      </TelemedicinePage>}
    </>
  );
}

export default TelemedicineMeeting;
